import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { SHARED_LOOKUP_CATEGORIES, SHARED_OFFERS, SHARED_ORGANISATIONS } from '@/shared/store/types'
import { Api } from '@/api/api'
import { emptySharedState, SharedState } from '@/shared/store/shared-state'
import { OfferLite } from '@/business/offers/models/offer-lite'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { toMap } from '@/shared/utils/map'
import { LookupItem } from '@/api/generated'

const STORE_NAME = 'shared'

@Module({
  name: STORE_NAME,
})
export class SharedModule extends VuexModule {
  public static readonly STORE_NAME: string = STORE_NAME

  public data: SharedState = emptySharedState()

  public get organisations(): OrganisationLite[] {
    return this.data.organisations
  }

  public clearResources(): void {
    this.data.resources = []
  }

  @Action({
    commit: SHARED_LOOKUP_CATEGORIES,
    rawError: true,
  })
  public fetchLookupCategories(): Promise<LookupItem[]> {
    let promise: Promise<LookupItem[]>

    // Fetch only the first time this action is dispatched
    if (this.data.categories.length === 0) {
      promise = Api.Lookup.getCategories()
    } else {
      promise = Promise.resolve(this.data.categories)
    }

    return promise
  }

  @Action({
    commit: SHARED_OFFERS,
    rawError: true,
  })
  public fetchSharedOffers(): Promise<OfferLite[]> {
    return Api.Offers.getOffers({
      page: 1,
      pageSize: 1000, // TODO This is okay for now but in the future we should use a server-side autocomplete
    }).then(response => response.items)
  }

  @Action({
    commit: SHARED_ORGANISATIONS,
    rawError: true,
  })
  public fetchSharedOrganisations(payload: {
    project: string | null
  }): Promise<OrganisationLite[]> {
    return Api.Organisations.getOrganisations({
      page: 1,
      pageSize: 1000, // TODO This is okay for now but in the future we should use a server-side autocomplete
      project: payload.project ?? undefined,
    }).then(result => result.items)
  }

  @Mutation
  public [SHARED_LOOKUP_CATEGORIES](categories: LookupItem[]): void {
    this.data.categories = categories
  }

  @Mutation
  public [SHARED_OFFERS](offers: OfferLite[]): void {
    this.data.offerMap = toMap(offers, 'id')
    this.data.offers = offers
  }

  @Mutation
  public [SHARED_ORGANISATIONS](organisations: OrganisationLite[]): void {
    this.data.organisationMap = toMap(organisations, 'id')
    this.data.organisations = organisations
  }
}
